(function () {
  'use strict';

  var CHECKOUT_ENDPOINT = 'https://pusher-p-shopping-pwa.onrender.com/api/storefront-checkout';
  var REIMBURSEMENT_HANDLE = 'consultant-reimbursement';
  var busy = false;

  function isReimbursement(item) {
    return item && (
      item.handle === REIMBURSEMENT_HANDLE ||
      item.properties && (item.properties._pusher_p_consultant_reimbursement === true || item.properties._pusher_p_consultant_reimbursement === 'true')
    );
  }

  function merchandiseLines(cart) {
    return (cart.items || []).filter(function (item) {
      return !isReimbursement(item);
    }).map(function (item) {
      return {
        merchandiseId: 'gid://shopify/ProductVariant/' + String(item.variant_id),
        quantity: Math.max(1, Number(item.quantity) || 1)
      };
    });
  }

  function removeLegacyReimbursement(cart) {
    var updates = {};
    (cart.items || []).forEach(function (item) {
      if (isReimbursement(item)) updates[item.key] = 0;
    });
    if (!Object.keys(updates).length) return Promise.resolve();
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function () {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }).catch(function () {});
  }

  function readCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(function (response) {
      if (!response.ok) throw new Error('The cart could not be loaded.');
      return response.json();
    });
  }

  function setBusy(button, value) {
    if (!button) return;
    if (value) {
      button.dataset.palaceOriginalText = button.textContent;
      button.textContent = 'Preparing secure checkout…';
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    } else {
      button.textContent = button.dataset.palaceOriginalText || 'Checkout';
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }

  function beginCheckout(button) {
    if (busy) return;
    busy = true;
    setBusy(button, true);
    readCart().then(function (cart) {
      var lines = merchandiseLines(cart);
      if (!lines.length) throw new Error('Your cart does not contain any merchandise.');
      return fetch(CHECKOUT_ENDPOINT, {
        method: 'POST',
        mode: 'cors',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ lines: lines })
      });
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (payload) {
        if (!response.ok) throw new Error(payload.error || 'Checkout could not be prepared.');
        return payload;
      });
    }).then(function (payload) {
      if (!payload.checkoutUrl) throw new Error('Shopify did not return a checkout link.');
      window.location.assign(payload.checkoutUrl);
    }).catch(function (error) {
      busy = false;
      setBusy(button, false);
      window.alert(error.message || 'Checkout could not be prepared. Please try again.');
    });
  }

  function checkoutControl(target) {
    if (!target || !target.closest) return null;
    var marked = target.closest('button[name="checkout"], input[name="checkout"], a[href^="/checkout"], [data-checkout-button], .cart__checkout, #checkout');
    if (marked) return marked;

    var control = target.closest('button, a, input[type="submit"]');
    if (!control) return null;
    var label = control.value || control.getAttribute('aria-label') || control.textContent || '';
    return /^\s*check\s*out\s*$/i.test(label) ? control : null;
  }

  document.addEventListener('click', function (event) {
    var control = checkoutControl(event.target);
    if (!control) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    beginCheckout(control);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[action^="/cart"]')) return;
    var submitter = event.submitter;
    if (!submitter || submitter.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    beginCheckout(submitter);
  }, true);

  readCart().then(removeLegacyReimbursement).catch(function () {});
}());
